export const MAX_LINKED_PDF_BYTES = 200 * 1024 * 1024

export function parsePdfLink(rawUrl: string, pageProtocol: string): URL {
  const value = rawUrl.trim()
  if (!value) throw new Error('PDF 링크를 입력하세요.')

  let url: URL
  try {
    url = new URL(value)
  } catch {
    throw new Error('http 또는 https PDF 링크를 정확히 입력하세요.')
  }

  if (!['http:', 'https:'].includes(url.protocol)) {
    throw new Error('http 또는 https PDF 링크만 사용할 수 있습니다.')
  }
  if (pageProtocol === 'https:' && url.protocol === 'http:') {
    throw new Error('HTTPS 화면에서는 HTTP PDF 링크를 열 수 없습니다.')
  }
  return url
}

export function filenameFromPdfUrl(url: URL): string {
  const encodedName = url.pathname.split('/').filter(Boolean).pop() || 'linked-score.pdf'
  let filename = encodedName
  try {
    filename = decodeURIComponent(encodedName)
  } catch {
    // 잘못 인코딩된 경로여도 원문 파일명을 사용하여 PDF 열기를 계속합니다.
  }
  return filename.toLowerCase().endsWith('.pdf') ? filename : `${filename}.pdf`
}

export async function hasPdfSignature(blob: Blob): Promise<boolean> {
  const header = new Uint8Array(await blob.slice(0, 5).arrayBuffer())
  return header.length === 5
    && header[0] === 0x25
    && header[1] === 0x50
    && header[2] === 0x44
    && header[3] === 0x46
    && header[4] === 0x2d
}
